import {createSelector} from 'reselect';

import {AppState} from './../../../store';

export const srpSelector = (state: AppState) => state.srp;

export const srpSelectorFn = createSelector(srpSelector, item => item);

export const srpDataSelectorFn = createSelector(srpSelectorFn, item => item.srpData);

export const srpOfferDataSelectorFn = createSelector(srpSelectorFn, item => item.srpOfferData);

export const srpConfigSelectorFn = createSelector(srpSelectorFn, item => item.srpConfig);

export const hasDataSelectorFn = createSelector(srpSelectorFn, item => item.hasData);

export const isSrpLoadingSelectorFn = createSelector(srpSelectorFn, item => item.isLoading);

export const isSrpSeoSelectorFn = createSelector(srpSelectorFn, item => item.isSEO);

export const faqDataSelectorFn = createSelector(srpSelectorFn, item => item.seoData.faqs);

export const seoBreadCrumbDataFn = createSelector(
  srpSelectorFn,
  item => item.seoData?.breadCrumbData || [],
);

export const seoFilterLinksFn = createSelector(
  srpSelectorFn,
  item => item.seoData?.filterLinks || [],
);
export const seoHelmetDataSelectorFn = createSelector(srpSelectorFn, item => ({
  seoLinks: item.seoData?.seoLinks || [],
  meta: item.seoData?.meta || [],
  pageTitle: item.seoData?.pageTitle || '',
}));
export const cityMetaInfoSelectorFn = createSelector(
  srpDataSelectorFn,
  item => item.city_meta_info,
);

export const segmentCollectionsFn = createSelector(cityMetaInfoSelectorFn, item => item?.sl || []);

export const appliedFilterSelectorFn = createSelector(srpConfigSelectorFn, item => item.filter);

export const topLocationsListSelectorFn = createSelector(cityMetaInfoSelectorFn, item => item.tl);

export const overrankVhidSelectorFn = createSelector(
  srpConfigSelectorFn,
  item => item?.overriderankvhids || '',
);

export const getTopLocationNameSelectorFn = createSelector(
  topLocationsListSelectorFn,
  (_, id: string) => id,
  (item, id) => {
    if (item && item.length > 0) item.find(subItem => subItem.id === id);
    return null;
  },
);

export const staticLocationsVoyagerIdsSelectorFn = createSelector(cityMetaInfoSelectorFn, item =>
  item && item.lli ? item.lli : {},
);

export const isRnplFilterSelector = createSelector(cityMetaInfoSelectorFn, item => !!item?.isrnpl);

export const getLocationIdSelectorFn = createSelector(
  staticLocationsVoyagerIdsSelectorFn,
  (_, name: string) => name,
  (item, name) => {
    if (item && Object.keys(item).length > 0)
      Object.keys(item).find(itemKey => item[itemKey] === name);
    return null;
  },
);

export const hotelChainListSelectorFn = createSelector(cityMetaInfoSelectorFn, item => {
  return item && item.hcl && item.hcl.length > 0 ? item.hcl.filter(item => item) : [];
});

export const staticFilterLocationsListSelectorFn = createSelector(cityMetaInfoSelectorFn, item => {
  return item && item.dsl && Array.isArray(item.dsl)
    ? item.dsl.map(staticLocationsData => ({
        name: staticLocationsData.n,
        count: staticLocationsData.ahc,
      }))
    : [];
});

export const staticFilterLocationsListSelector = createSelector(
  [staticFilterLocationsListSelectorFn, staticLocationsVoyagerIdsSelectorFn],
  (locationFilterCheckboxList, staticLocationsNamesIdMap) => {
    return {
      locationFilterCheckboxList,
      staticLocationsNamesIdMap,
    };
  },
);

// For About City
export const isSEOSelector = createSelector(srpSelector, item => item?.isSEO);
export const aboutCitySelector = createSelector(srpSelector, item => item?.seoData?.article);
export const topContentSelector = createSelector(srpSelector, item => item?.seoData?.topContent);
export const seoSrpPageTitleSelectorFn = createSelector(
  srpSelector,
  item => item?.seoData?.pageHeading || '',
);

export const seoViewMoreSelectorFn = createSelector(
  srpConfigSelectorFn,
  item => item?.seoViewMore || false,
);

export const displayOverlayForFilterSelector = createSelector(
  srpSelector,
  item => item?.displayOverlay || false,
);
